export default "__VITE_ASSET__BUXVmCRv__"